import { Box, MenuItem, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import {
  SettingItemObjType,
  videoModelType,
  VideoSettings,
} from "../../../../Types/VideoSuite-Types";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "@mui/icons-material/Check";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SeedParameter from "../../../SharedSuite/SeedParameter";
interface VideoSuiteAppSettingsProps {
  selectedVideoSettings: {
    selectedSize: string;
    selectedModel: videoModelType;
    selectedMode: string;
    selectedDuration: string;
    selectedStyle: SettingItemObjType;
    seed: number | null;
  };
  showMoreSettings: boolean;
  setShowMoreSettings: (flag: boolean) => void;
  handleModelSettingChanges: (
    name: string,
    value: string | SettingItemObjType | videoModelType
  ) => void;
  videoAppSettings: VideoSettings[];
  openLockSeed: boolean;
  toggleLockSeed: (flag: boolean) => void;
  showSetting?: {
    models: boolean;
    dimensions: boolean;
    seed: boolean;
    style: boolean;
    duration: boolean;
    modes: boolean;
    quality: boolean;
  };
}

const VideoAppSettings = ({
  selectedVideoSettings,
  handleModelSettingChanges,
  showMoreSettings,
  openLockSeed,
  toggleLockSeed,
  setShowMoreSettings,
  videoAppSettings,
  showSetting = {
    models: true,
    dimensions: true,
    seed: true,
    style: true,
    duration: true,
    modes: true,
    quality: true,
  },
}: VideoSuiteAppSettingsProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [listsVisibility, setListsVisibility] = useState({
    models: isMobile,
    dimensions: !isMobile,
    styles: !isMobile,
    durations: !isMobile,
    modes: !isMobile,
    seed: !isMobile,
  });

  const selectedModelData = videoAppSettings?.find(
    (model) => model.name === selectedVideoSettings.selectedModel.name
  );

  const toggleList = (listName: keyof typeof listsVisibility) => {
    if (isMobile) {
      setListsVisibility((prev) => ({
        ...prev,
        [listName]: !prev[listName],
      }));
    }
  };

  const toggleShowSettings = () => {
    setShowMoreSettings(!showMoreSettings);
  };

  return (
    <Box sx={{ width: "100%" }} className="video-app-settings">
      {/* models */}
      {showSetting.models && (
        <Box className="setting-item" sx={{ mt: "24px", mb: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography className="settings-title" sx={{ marginBottom: 1 }}>
              Model
            </Typography>
            <span
              className="arrow-container d-flex justify-content-center align-items-center"
              onClick={() => toggleList("models")}
            >
              {isMobile ? (
                listsVisibility?.models ? (
                  <ArrowUpIcon className="return-versions-arrow-white-black" />
                ) : (
                  <ArrowDown className="return-versions-arrow-white-black" />
                )
              ) : null}
            </span>
          </Box>
          {(listsVisibility?.models || !isMobile) && (
            <Box className="list">
              {videoAppSettings?.map((model, i) => (
                <MenuItem
                  key={i}
                  className={`list-item ${
                    model.name === selectedVideoSettings.selectedModel.name &&
                    "selected-model"
                  }`}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() =>
                    handleModelSettingChanges("selectedModel", {
                      name: model.name,
                      version: model.version,
                    })
                  }
                >
                  <Typography className="list-item-title">
                    {model.name}
                  </Typography>
                </MenuItem>
              ))}
            </Box>
          )}
        </Box>
      )}
      {/* More settings */}
      <Box sx={{
        p:1,
        borderRadius: "8px",
         background: "var(--suiteMoreSettings)"
      }}>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            borderTop: "2px solid var(--A-background55)",
            flexGrow: 1,
            marginBottom: "8px",
          }}
        ></Box>
        <Box
        className={`suite-app-settings-header ${
              showMoreSettings && "mb-2"
            }`}
          sx={{
            display: "flex",
            flexDirection:"row-reverse",
            cursor: "pointer",
          }}
          onClick={toggleShowSettings}
        >
          {showMoreSettings ? (
            <ArrowUpIcon className="blue-arrow" />
          ) : (
            <ArrowDown className="blue-arrow" />
          )}
          <Typography className="more-settings">
            More settings
          </Typography>
        </Box>
      </Box>
      {showMoreSettings ? (
        <>
          {/* Dimensions */}
            {showSetting.dimensions && selectedModelData?.modelDimensions &&
              selectedModelData?.modelDimensions?.length > 0 ? (
            <Box className="setting-item">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography className="settings-title" sx={{ marginBottom: 1 }}>
                  Dimension
                </Typography>
                <span
                  className="arrow-container d-flex justify-content-center align-items-center"
                  onClick={() => toggleList("dimensions")}
                >
                  {isMobile ? (
                    listsVisibility?.dimensions ? (
                      <ArrowUpIcon className="return-versions-arrow-white-black" />
                    ) : (
                      <ArrowDown className="return-versions-arrow-white-black" />
                    )
                  ) : null}
                </span>
              </Box>
              {(listsVisibility?.dimensions || !isMobile) && (
                <Box className="list">
                  {selectedModelData?.modelDimensions?.map((dimension, i) => {
                    const size = dimension.description;
                    return (
                      <MenuItem
                        key={i}
                        className={`list-item ${
                          size === selectedVideoSettings.selectedSize &&
                          "selected-size"
                        }`}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() =>
                          handleModelSettingChanges("selectedSize", size)
                        }
                      >
                        <Box
                          className={`item-size-${size?.replace(":", "-")}`}
                        ></Box>
                        <Typography className="list-item-title">
                          {size}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                </Box>
              )}
            </Box>
          ) : null}
          {/* Styles */}
          {showSetting.style &&
            selectedModelData &&
            selectedModelData?.modelStyles?.length > 1 && (
              <Box className="setting-item">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    className="settings-title"
                    sx={{ marginBottom: 1 }}
                  >
                    Style
                  </Typography>
                  <span
                    className="arrow-container d-flex justify-content-center align-items-center"
                    onClick={() => toggleList("styles")}
                  >
                    {isMobile ? (
                      listsVisibility?.styles ? (
                        <ArrowUpIcon className="return-versions-arrow-white-black" />
                      ) : (
                        <ArrowDown className="return-versions-arrow-white-black" />
                      )
                    ) : null}
                  </span>
                </Box>
                {(listsVisibility?.styles || !isMobile) && (
                  <Box className="list">
                    {selectedModelData?.modelStyles?.map((styleObj, i) => {
                      const style = styleObj.description;
                      return (
                        <Card
                          className={`video-suite-setting-style ${
                            style === "3D Animation" && "ThreeD-animationImage"
                          } ${style.toLowerCase().replace(/\s+/g, "")}Image ${
                            style ===
                              selectedVideoSettings.selectedStyle.description &&
                            "selected"
                          }`}
                          onClick={() =>
                            handleModelSettingChanges("selectedStyle", styleObj)
                          }
                          sx={{
                            height:"80px"
                          }}
                        >
                          <CardContent
                            sx={{
                              padding: "0px",
                              paddingTop: "48px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Roboto",
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "25px",
                                letterSpacing: "0.1px",
                                textAlign: "center",
                                color: "#FFFFFF",
                              }}
                            >
                              {style}
                            </Typography>
                          </CardContent>
                          {style ===
                            selectedVideoSettings.selectedStyle.description && (
                            <Box
                              sx={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "16px",
                                padding: "5px 11px",
                                gap: "8px",
                                background: "#12B6EA",
                                position: "absolute",
                                top: "2%",
                                right: "2%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckIcon
                                sx={{
                                  width: "18px",
                                  height: "18px",
                                  color: "white",
                                }}
                              />
                            </Box>
                          )}
                        </Card>
                      );
                    })}
                  </Box>
                )}
              </Box>
            )}
          {/* Durations */}
            {showSetting.duration && selectedModelData?.modelDurations
              && selectedModelData?.modelDurations.length > 0 ? (
            <Box className="setting-item">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography className="settings-title" sx={{ marginBottom: 1 }}>
                  Duration
                </Typography>
                <span
                  className="arrow-container d-flex justify-content-center align-items-center"
                  onClick={() => toggleList("durations")}
                >
                  {isMobile ? (
                    listsVisibility?.durations ? (
                      <ArrowUpIcon className="return-versions-arrow-white-black" />
                    ) : (
                      <ArrowDown className="return-versions-arrow-white-black" />
                    )
                  ) : null}
                </span>
              </Box>
              {(listsVisibility?.durations || !isMobile) && (
                <Box className="list">
                  <>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={selectedVideoSettings.selectedDuration}
                      onChange={(e) =>
                        handleModelSettingChanges(
                          "selectedDuration",
                          e.target.value
                        )
                      }
                    >
                      {selectedModelData?.modelDurations?.map(
                        (durationObj, i) => {
                          return (
                            <FormControlLabel
                              key={i}
                              value={durationObj.value}
                              className="me-4 pe-3"
                              control={
                                <Radio
                                  sx={{
                                    color: "#76CFEB33",
                                    "&.Mui-checked": {
                                      color: "#12B6EA",
                                    },
                                  }}
                                />
                              }
                              label={`${String(durationObj.value)} s`}
                            />
                          );
                        }
                      )}
                    </RadioGroup>
                  </>
                </Box>
              )}
            </Box>
          ) : null}
          {/* Modes */}
            {showSetting.modes && selectedModelData?.modelVideoQualities
              && selectedModelData?.modelVideoQualities.length > 0 ? (
            <Box className="setting-item">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography className="settings-title" sx={{ marginBottom: 1 }}>
                  Quality
                </Typography>
                <span
                  className="arrow-container d-flex justify-content-center align-items-center"
                  onClick={() => toggleList("modes")}
                >
                  {isMobile ? (
                    listsVisibility?.modes ? (
                      <ArrowUpIcon className="return-versions-arrow-white-black" />
                    ) : (
                      <ArrowDown className="return-versions-arrow-white-black" />
                    )
                  ) : null}
                </span>
              </Box>
              {(listsVisibility?.modes || !isMobile) && (
                <Box className="list">
                  {selectedModelData?.modelVideoQualities?.map((modeObj, i) => {
                    const mode = modeObj.description;
                    return (
                      <MenuItem
                        key={i}
                        className={`list-item ${
                          mode === selectedVideoSettings.selectedMode &&
                          "selected-size"
                        }`}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() =>
                          handleModelSettingChanges("selectedMode", mode)
                        }
                      >
                        <Typography className="list-item-title">
                          {mode}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                </Box>
              )}
            </Box>
          ) : null}
        </>
      ) : null}
      </Box>
    </Box>
  );
};

export default VideoAppSettings;
